import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import environment from "../../utils/Environment";
import { getGemsTokenContract } from "../../utils/contractHelpers";

const ApproveGems = () => {
  const web3 = useWeb3();

  const approveGems = useCallback(
    async (account, amount, tokenAddress, decimals) => {
      // console.log(amount, tokenAddress, decimals, 'approveGems');

      const contract = getGemsTokenContract(tokenAddress, web3);
      let nd = '999999999999999999999999999999999999999999999999'// '9999999999999999999999999';
      // console.log(nd, 'ndndndndndndndn');

      try {
        // const gas = await contract.methods
        //   .approve(environment.GEMSSubscription, nd)
        //   .estimateGas({ from: account });

        const details = await contract.methods
          .approve(environment.GEMSSubscription, nd)
          .send({
            from: account,
            // gas,
          });
        return details;
      } catch (error) {
        // console.log("Error in approveGems:", error);
        throw error;
      }
    },
    [web3]
  );
  return { approveGems: approveGems };
};
export default ApproveGems;
